const CHIROUP_ADMIN_EMAIL_PATTERN = /^[^\s@]+@chiroup\.com$/i;

export const isChiroupAdminEmail = (email: unknown): email is string =>
  typeof email === 'string' && CHIROUP_ADMIN_EMAIL_PATTERN.test(email.trim());
